import { render } from "./AllDocumentsPage.vue?vue&type=template&id=266be3c9&scoped=true"
import script from "./AllDocumentsPage.vue?vue&type=script&lang=js"
export * from "./AllDocumentsPage.vue?vue&type=script&lang=js"

import "./AllDocumentsPage.vue?vue&type=style&index=0&id=266be3c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266be3c9"]])

export default __exports__